import { type FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";

interface Props {
  disabled?: boolean;
  clickHandler: () => void;
}

const ToReviewButton: FC<Props> = ({ disabled, clickHandler }) => {
  const { t } = useTranslation();

  return (
    <Button data-test-id={"btn-checkout"} disabled={disabled} onClick={clickHandler}>
      {t("activeQuotePage.send")}
    </Button>
  );
};

export default memo(ToReviewButton);
